import type { UploadFileTypesInfoProps } from "./upload-file-types-info.type";

import { QuestionCircleOutlined } from "@ant-design/icons";
import { Tooltip, Typography } from "antd";
import { useTranslation } from "react-i18next";

import { getTooltipGridColsAndRows } from "./upload-file-types-info.helper";

import "./upload-file-types-info.style.less";

const { Text } = Typography;

const UploadFileTypesInfo = ({
  authorizedFileTypes,
  asSentence,
}: UploadFileTypesInfoProps) => {
  const { t } = useTranslation();

  const title = t("global:upload.authorizedFileTypes");

  const fileTypes = authorizedFileTypes.map((authorizedFileTypes) =>
    authorizedFileTypes.replace(".", "")
  );

  if (asSentence) {
    return <Text>{`${title}: ${fileTypes.join(", ")}.`}</Text>;
  }

  const { cols, rows } = getTooltipGridColsAndRows(fileTypes);
  const gridTemplate = `repeat(${rows}, 1fr) / repeat(${cols}, 1fr)`;

  return (
    <Tooltip
      styles={{ root: { maxWidth: "none" } }}
      title={
        <ul className="upload-file-types-info-tooltip" style={{ gridTemplate }}>
          {fileTypes.map((type) => (
            <li key={type}>{type}</li>
          ))}
        </ul>
      }
    >
      <Text>
        <span className="upload-file-types-info-text">{title}</span>{" "}
        <QuestionCircleOutlined />
      </Text>
    </Tooltip>
  );
};

export default UploadFileTypesInfo;
